module.exports = __webpack_public_path__ + "media/images/google+-cd1a897da7cd290816bb39f180fd9ff9.png";